import React, { useState, useEffect } from "react";
import './formEvaluationAnswerGroup.css';
import { Input, Button, Select, Divider, Typography, Space, Row, Col, InputNumber, Modal } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { TextArea } = Input;

const FormEvaluationAnswerGroup = ({ evaluationAnswerGroup, setIsEditing, createEvaluationAnswerGroup, updateEvaluationAnswerGroup, organizationsData }) => {
    const [eagId, setEagId] = useState(evaluationAnswerGroup.eag_id || null);
    const [eagTitle, setEagTitle] = useState(evaluationAnswerGroup.eag_title || "");
    const [eagDescription, setEagDescription] = useState(evaluationAnswerGroup.eag_description || "");
    const [eagType, setEagType] = useState(evaluationAnswerGroup.eag_type || null);
    const [eagMinValue, setEagMinValue] = useState(evaluationAnswerGroup.eag_min_value || 1);
    const [eagMaxValue, setEagMaxValue] = useState(evaluationAnswerGroup.eag_max_value || 5);
    const [eagTarget, setEagTarget] = useState(evaluationAnswerGroup.eag_target || null);
    const [eagOptions, setEagOptions] = useState(evaluationAnswerGroup.eag_options || []);

    // Guardamos el estado inicial para comparar cambios
    const [initialState, setInitialState] = useState({});

    useEffect(() => {
        setEagId(evaluationAnswerGroup.eag_id || null);
        setEagTitle(evaluationAnswerGroup.eag_title || "");
        setEagDescription(evaluationAnswerGroup.eag_description || "");
        setEagType(evaluationAnswerGroup.eag_type ?? null);
        setEagMinValue(evaluationAnswerGroup.eag_min_value ?? 1);
        setEagMaxValue(evaluationAnswerGroup.eag_max_value ?? 5);
        setEagTarget(
            evaluationAnswerGroup.eag_target === 0
                ? 0
                : evaluationAnswerGroup.eag_target || null
        );
        setEagOptions(evaluationAnswerGroup.eag_options || []);

        setInitialState({
            eagTitle: evaluationAnswerGroup.eag_title || "",
            eagDescription: evaluationAnswerGroup.eag_description || "",
            eagType: evaluationAnswerGroup.eag_type ?? null,
            eagMinValue: evaluationAnswerGroup.eag_min_value ?? 1,
            eagMaxValue: evaluationAnswerGroup.eag_max_value ?? 5,
            eagTarget:
                evaluationAnswerGroup.eag_target === 0
                    ? 0
                    : evaluationAnswerGroup.eag_target || null,
            eagOptions: evaluationAnswerGroup.eag_options || [],
        });
    }, [evaluationAnswerGroup]);

    const rellenarFormulario = () => {
        setEagId(null);
        setEagTitle("Opción Múltiple, Respuesta única (Cumplimiento)");
        setEagDescription(`Por favor, lee cuidadosamente las opciones presentadas y selecciona solo una que represente tu respuesta.
        Cada opción tiene un pequeño círculo a su lado. Para elegir, haz clic sobre el círculo correspondiente a la respuesta que consideres más adecuada.
        Recuerda que solo puedes seleccionar una opción.
Antes de continuar, asegúrate de que tu elección refleje correctamente tu decisión.`);
        setEagType(1);
        setEagMinValue(1);
        setEagMaxValue(5);
        setEagTarget(0);
        setEagOptions([
            { eao_option: '1', eao_text: 'Nunca', eao_value: 1 },
            { eao_option: '2', eao_text: 'Casi nunca', eao_value: 2 },
            { eao_option: '3', eao_text: 'A veces', eao_value: 3 },
            { eao_option: '4', eao_text: 'Casi siempre', eao_value: 4 },
            { eao_option: '5', eao_text: 'Siempre', eao_value: 5 }
        ]);
    }

    const handleAddOption = () => {
        setEagOptions(prev => ([...prev, { eao_option: '', eao_text: '', eao_value: null }]));
    };

    const handleChangeOption = (index, key, value) => {
        const newOptions = [...eagOptions];
        newOptions[index][key] = value;
        setEagOptions(newOptions);
    };

    const handleRemoveOption = (index) => {
        const newOptions = [...eagOptions];
        newOptions.splice(index, 1);
        setEagOptions(newOptions);
    };

    const handleCancel = () => {
        const hasChanges =
            eagTitle !== initialState.eagTitle ||
            eagDescription !== initialState.eagDescription ||
            eagType !== initialState.eagType ||
            eagMinValue !== initialState.eagMinValue ||
            eagMaxValue !== initialState.eagMaxValue ||
            eagTarget !== initialState.eagTarget ||
            JSON.stringify(eagOptions) !== JSON.stringify(initialState.eagOptions);

        if (hasChanges) {
            Modal.confirm({
                title: "Hay cambios sin guardar",
                content: "¿Seguro que deseas cancelar? Los cambios realizados se perderán.",
                okText: "Sí, cancelar",
                cancelText: "No",
                onOk() {
                    setIsEditing(false);
                },
            });
        } else {
            setIsEditing(false);
        }
    };

    const handleSave = () => {
        let objEvaluationAnswerGroup = {
            eag_id: eagId,
            eag_title: eagTitle,
            eag_description: eagDescription,
            eag_type: eagType,
            eag_min_value: eagMinValue,
            eag_max_value: eagMaxValue,
            eag_target: eagTarget,
            eag_options: eagOptions,
        };
        if (eagId == null) {
            createEvaluationAnswerGroup(objEvaluationAnswerGroup);
        } else {        
            updateEvaluationAnswerGroup(objEvaluationAnswerGroup);    
        }
    }

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            {/* Nombre de la escala */}
            <div>
                <Text strong type="secondary">Nombre de la escala</Text>
                <Input
                    style={{ width: "100%", marginTop: 4 }}
                    value={eagTitle}
                    onChange={(e) => setEagTitle(e.target.value)}
                    placeholder="Título de la escala"
                />
            </div>

            {/* Descripción de la escala */}
            <div>
                <Text strong type="secondary">Descripción de la escala</Text>
                <TextArea
                    style={{ width: "100%", marginTop: 4 }}
                    autoSize={{ minRows: 2 }}
                    value={eagDescription}
                    onChange={(e) => setEagDescription(e.target.value)}
                    placeholder="Descripción de la escala"
                />
            </div>

            {/* Tipo de respuesta */}
            <div>
                <Text strong type="secondary">Tipo de respuesta</Text>
                <Select
                    style={{ width: "100%", marginTop: 4 }}
                    value={eagType}
                    onChange={(value) => setEagType(value)}
                    placeholder="Tipo de respuesta"
                    options={[
                        { value: 1, label: "Opción múltiple, respuesta única" },
                        { value: 2, label: "Opción múltiple, respuesta múltiple" },
                        { value: 3, label: "Respuesta abierta" },
                        { value: 4, label: "Rango numérico" },
                    ]}
                />
            </div>

            {/* ¿Quién puede ver la escala? */}
            <div>
                <Text strong type="secondary">¿Quién puede ver la escala?</Text>
                <Select
                    style={{ width: "100%", marginTop: 4 }}
                    value={eagTarget}
                    onChange={(value) => setEagTarget(value)}
                    placeholder="Seleccione una opción"
                    showSearch
                    optionFilterProp="label"
                    options={[
                        { value: 0, label: "Todas las organizaciones" },
                        ...organizationsData.map(org => ({
                            value: org.org_id,
                            label: org.org_name,
                        }))
                    ]}
                />

            </div>

            {/* Configuración de opciones de respuesta */}
            {
                (eagType !== 3 && eagType !== null) && <Text strong type="secondary">Configuración de opciones de respuesta</Text>
            }

            {(eagType === 1 || eagType === 2) && (
                <div>
                    <Button type="dashed" icon={<PlusOutlined />} onClick={handleAddOption} style={{ marginBottom: 12 }}>
                        Agregar opción
                    </Button>

                    {eagOptions.length > 0 && (
                        <Row gutter={12} style={{ marginBottom: 8 }}>
                            <Col align="center" span={4}><Text strong>Opción</Text></Col>
                            <Col align="center" span={12}><Text strong>Texto</Text></Col>
                            <Col align="center" span={4}><Text strong>Valor</Text></Col>
                        </Row>
                    )}

                    {eagOptions.map((option, index) => (
                        <Row key={index} gutter={12} style={{ marginBottom: 8 }} align="middle">
                            <Col span={4}>
                                <Input
                                    placeholder="Opción"
                                    value={option.eao_option}
                                    onChange={e => handleChangeOption(index, 'eao_option', e.target.value)}
                                />
                            </Col>
                            <Col span={12}>
                                <Input
                                    placeholder="Texto"
                                    value={option.eao_text}
                                    onChange={e => handleChangeOption(index, 'eao_text', e.target.value)}
                                />
                            </Col>
                            <Col span={4}>
                                <InputNumber
                                    placeholder="Valor"
                                    value={option.eao_value}
                                    onChange={value => handleChangeOption(index, 'eao_value', value)}
                                    style={{ width: '100%' }}
                                />
                            </Col>
                            <Col span={2}>
                                <Button
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => handleRemoveOption(index)}
                                    disabled={eagOptions.length === 1}
                                />
                            </Col>
                        </Row>
                    ))}
                </div>
            )}

            {(eagType === 4) && (
                <>
                    <div>
                        <Text strong type="secondary">Valor mínimo</Text>
                        <InputNumber
                            style={{ width: "100%", marginTop: 4 }}
                            value={eagMinValue}
                            onChange={(value) => setEagMinValue(value)}
                            placeholder="Valor mínimo"
                        />
                    </div>

                    <div>
                        <Text strong type="secondary">Valor máximo</Text>
                        <InputNumber
                            style={{ width: "100%", marginTop: 4 }}
                            value={eagMaxValue}
                            onChange={(value) => setEagMaxValue(value)}
                            placeholder="Valor máximo"
                        />
                    </div>
                </>
            )}

            {/* Botones finales */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                {/* <Button onClick={rellenarFormulario}>
                    Rellenar
                </Button> */}
                <Button onClick={handleCancel}>
                    Cancelar
                </Button>
                <Button type="primary" onClick={handleSave}>
                    Guardar
                </Button>
            </div>
        </Space>
    );
};

export default FormEvaluationAnswerGroup;
